import { render, staticRenderFns } from "./FileUploadAndProcess.vue?vue&type=template&id=6b9d1930&scoped=true&"
import script from "./FileUploadAndProcess.vue?vue&type=script&lang=js&"
export * from "./FileUploadAndProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d1930",
  null
  
)

export default component.exports